import * as service from './service'
export default {
  namespace: 'sendOrdersHome',
  state: {
    demoData: {}
  },
  effects: {
    * workLimitMustJoinAssign ({ payload }, { call, put }) {
      const res = yield call(service.workLimitMustJoinAssign, payload)
      return res.data.data
    },
    * assignMod ({ payload }, { call, put }) {
      const res = yield call(service.assignMod, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
